var viewer_default = {
  "gallery_container": "R52hk",
  "imageTitleContainer": "TwwFB",
  "clickableItem": "p0qq6",
  "prerender": "HvXmH",
  "expandButton": "Le964",
  "itemContainer": "jx-8T",
  "expandIcon": "zJhTD",
  "itemOverlay": "UdSGl",
  "imageTitle": "LbemF",
  "pointer": "mXf1V",
  "fadeIn": "ISvhw",
  "changing_background": "tfkzd"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
